import { useEffect } from 'react';

interface UseArcKeyboardControlsParams {
  currentStrokeIndex: number;
  strokeCount: number;
  togglePlay: () => void;
  seekToStroke: (strokeIndex: number) => void;
}

export const useArcKeyboardControls = ({
  currentStrokeIndex,
  strokeCount,
  togglePlay,
  seekToStroke,
}: UseArcKeyboardControlsParams) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      const tagName = target?.tagName;
      const isInteractive =
        target?.isContentEditable ||
        tagName === 'INPUT' ||
        tagName === 'TEXTAREA' ||
        tagName === 'SELECT' ||
        tagName === 'BUTTON';

      if (isInteractive) {
        return;
      }

      if (event.code === 'Space') {
        event.preventDefault();
        togglePlay();
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        seekToStroke(Math.max(0, currentStrokeIndex - 1));
        return;
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        seekToStroke(Math.min(strokeCount - 1, currentStrokeIndex + 1));
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentStrokeIndex, seekToStroke, strokeCount, togglePlay]);
};
